@if (uiController === UIControlTyp.InputField) {
  <input class="form-control" [ngModel]='values' (ngModelChange)='onChange($event)'>
}
@if (uiController === UIControlTyp.GridSingleValueField) {
  {{ values }}
}
